import type { ArticleAuthorForJsonLd } from '../../types/article-author-seo';
import { buildAshtonSameAsForJsonLd } from '../authors/ashton-personal-social-links';
import { BASE_URL } from '../constants/url-constants';

/** Path under site `public/` (served as static asset). */
export const ASHTON_ARTICLE_AUTHOR_HEADSHOT_PATH = '/authors/ashton-spina-headshot.png';

export const ASHTON_ARTICLE_AUTHOR_IMAGE_URL = `${BASE_URL}${ASHTON_ARTICLE_AUTHOR_HEADSHOT_PATH}`;

/**
 * Byline + Person JSON-LD for articles Ashton writes (e.g. best job sites guide, cool Finnish tech employers).
 */
export const ASHTON_ARTICLE_AUTHOR: ArticleAuthorForJsonLd = {
  name: 'Ashton Spina',
  url: 'https://www.ashtonspina.com/',
  /** Personal profiles from {@link https://www.ashtonspina.com/ ashtonspina.com} + JobCrawls author URL. */
  sameAs: buildAshtonSameAsForJsonLd(BASE_URL),
  image: ASHTON_ARTICLE_AUTHOR_IMAGE_URL,
  credentials:
    'Co-founder and engineer of JobCrawls. Previously worked in software engineering and engineering management on marketplace products at Homegate AG and SMG (Swiss Marketplace Group) in Zurich, before relocating to Helsinki, where he writes research-led guides on the Finnish job market.',
};
